import { ModalComponent } from "cruzo/ui-components/modal";
import { appScope } from "site/api";
import { EditorLessonLockError, formatEditorLockHolder } from "site/services/editor-lock.service";

let message = "Урок недоступен для редактирования.";

export function editorLockModalMessage(): string {
  return message;
}

export function showEditorLockModal(err: EditorLessonLockError): void {
  const holder = err.holderEmail.trim();
  message = holder
    ? `Урок сейчас редактирует ${formatEditorLockHolder(holder)}. Доступен только просмотр.`
    : "Урок недоступен для редактирования.";
  ModalComponent.attach("editorLockModal", appScope.id);
}
